// Redux-Form names

export const PARTNER_VAST_FORM = "partner-vast";
